import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { DataManipService } from '../../Services/data-manip.service';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
@Component({
  selector: 'app-log-of-test-balance',
  templateUrl: './log-of-test-balance.component.html',
  styleUrls: ['./log-of-test-balance.component.scss']
})
export class LogOfTestBalanceComponent implements OnInit {



  users=[
    {
      display:"",
      value:null
    }
  ];
  showLoader: boolean = false;
  tableconfig={};
  tableheaders=[];
  tabledata=[];
  showGtPlusTbl=false;
  userid=0;
  showwalletGtPlusTbl=false;
  showTestGtPlusTbl=false;
  constructor(private encryptService : EncrptDecreptService, private router: Router, private datePipe:DatePipe, public dataManipSrvc: DataManipService, private commonServices: CommonService, private configSetting: ConfigSettingService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.dataManipSrvc.headerName = "Users Test Details";
    }, 80);
    this.getAllUsers();
    this.onOptionsSelected();
  }

  getAllUsers(){
    
    //this.showLoader = true;
    let apiUrl = this.configSetting.getBaseUrl() + "user/getAllRegisterUserList";
    this.users.push({
      display:"ALL",
      value:0
    })

    this.commonServices.getMethod(apiUrl).subscribe(successResp => {
     // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {    
        let tableheaders = successResp["Data"][0]["@Oritbl"]["tableheaders"];
        let tableconfig = successResp["Data"][0]["@Oritbl"]["tableconfig"];
        let tabledata = successResp["Data"][0]["@Oritbl"]["tabledata"];
      
        //this.downloadtestmodal.show();
       // this.showGtPlusTbl = true;

        for(let i=0;i<tabledata.length;i++){
          this.users.push({
            display:tabledata[i]['username'],
            value:tabledata[i]['userid']
          })
        }
      }
    })
  }

  onOptionsSelected(){
    this.showTestGtPlusTbl=false;
    this.tableheaders = [];
    this.tableconfig = [];
    this.tabledata =[];
  // console.log(this.userid)
      let apiUrl = this.configSetting.getBaseUrl() + "user/getuserTakingtestListReport";
   

      let body = {
        "userid": +this.userid,
      }
  
      this.commonServices.getWithParams(apiUrl, body).subscribe(successResp => {
     // this.showLoader = false;
      if (successResp['errorCode'] == "000000") {  
        this.showTestGtPlusTbl=true;  
        this.tableheaders = successResp["Data"]["tableheaders"];
        this.tableconfig = successResp["Data"]["tableconfig"];
        this.tabledata = successResp["Data"]["tabledata"];
        this.tableconfig['actioncolmconfig']['print']=false;
        this.tableconfig['actioncolmconfig']['view']=false;
        this.tableconfig['actioncolmconfig']['edit']=false;
        this.tableconfig['dragdrop']['columns'] = false;
      }
    })
    
  }
  downloadReport(event){
    this.showLoader = true;
   let params =
   {
     "userid": this.encryptService.encrypt(event["row"]["userid"]+""),
     "testid": this.encryptService.encrypt(event["row"]["testid"]+""),
     "usertestid":  this.encryptService.encrypt(event["row"]["usertestid"]+"")
   };
   let apiUrl = this.configSetting.getBaseUrl() + "dashtest/downloadResultPDF";
   this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

     var blob = new Blob([successResp], { type: 'application/pdf' });
     var url = window.URL.createObjectURL(blob);
     let testDate = this.datePipe.transform( event["row"]["testcompletedon"], "dd-MMM-yyyy");
     let a = document.createElement('a');
     document.body.appendChild(a);
     a.setAttribute('style', 'display: none');
     a.href = url;
     //  a.download = this.userTests[i]["testname"]["testname"] + "_" + testDate;
     a.download =  event["row"]["testname"] + "_" + testDate;
     a.click();
     window.URL.revokeObjectURL(url);
     a.remove();
     this.showLoader = false;
   },
     err => {
       alert("Problem while downloading the file.");

       console.error(err);
     }
   );
 }
}
